<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Layout Dashboard" class="d-icon d-icon--layout-dashboard" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M1 1.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5H1.5A.5.5 0 0 1 1 6V1.5ZM2 2v3.5h2.5V2H2Zm4.5-.5A.5.5 0 0 1 7 1h3.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V1.5Zm1 .5v1.5H10V2H7.5Zm-1 4a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V6Zm1 .5V10H10V6.5H7.5ZM1 8a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1-.5-.5V8Zm1 .5V10h2.5V8.5H2Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLayoutDashboard',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
